import React from 'react';
import { useQuery } from 'react-query';
import { UserTraitsResponse, WHOAMI_CACHE_KEY } from '@myme/api';
import { getAdditionalUserInformation } from '@myme/logic';
import { handleVerifyUser } from '@myme/logic/src/kratos';
import { mapToAuthUser } from './mapToAuthUser';
import { AuthAction, AuthState, UserData } from './types';

export const useInitializeAuth = (
  dispatch: React.Dispatch<AuthAction>,
  overrideInitialState: AuthState | undefined
) => {
  useQuery(
    [WHOAMI_CACHE_KEY],
    async () => {
      const kratosUser = await handleVerifyUser();
      const additionalUserInformation = await getAdditionalUserInformation();

      const userData: UserData = {
        ...(kratosUser.data.identity.traits as UserTraitsResponse),
        ...additionalUserInformation.data
      };
      return userData;
    },
    {
      retry: false,
      refetchInterval: 1000 * 10 * 60, // 10 minutes
      refetchIntervalInBackground: true,
      enabled: !overrideInitialState,
      onSuccess: data => {
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: true,
            user: mapToAuthUser(data)
          }
        });
      },
      onError: () => {
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null
          }
        });
      }
    }
  );
};
